export let unknownSenderOrRecipient = "Fe_HIe";
export default {unknownSenderOrRecipient};